module.exports = __webpack_public_path__ + "img/Poorter_hotel-071.2add6912.jpg";